const layoutStyle = {
    gridContainer: {
        height: '72vh',
        maxHeight: '72vh',
        paddingBottom: '24px',
        paddingRight: '24px',
        marginTop: '36px',
        borderRadius: '8px',
        direction: 'row',
        justifyContent: 'space-between',
        flexGrow: 1,
    },

    contentSection: {
        boxSizing: 'border-box',
        height: '100%',
        width: '100%',
    },
};

export const getStyles = ({ palette }) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100vh',
            position: 'fixed',
            top: 0,
            m: 0,
            boxSizing: 'border-box',
            padding: '0 16px',
            zIndex: 10,
            backgroundColor: palette.background.default,
        },
        title: {
            color: palette.text.textPrimary,
            flexShrink: 0,
            height: '60px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '12px 16px 0 16px',
            width: 'calc(100vw-40px)',
        },
        closeIcon: {
            border: `1px solid ${palette.button.buttonSecondary}`,
            borderRadius: '6px',
            padding: '8px',
        },
        content: {
            flexGrow: 1,
        },
        titleHover: { whiteSpace: 'nowrap', fontSize: '16px' },
    };
};

export default layoutStyle;
